// extracted by mini-css-extract-plugin
export default {"table":"SkrappyTable_table__rHlxp","tablePagination":"SkrappyTable_tablePagination__O6+W2","navigationArrow":"SkrappyTable_navigationArrow__LfF9a"};